import type { FetchSuggestedTopicsResponse } from '@atlassian/jira-servicedesk-knowledge-common/src/services/fetch-suggested-topics/types.tsx';
import {
	FETCH_SUGGESTED_TOPICS_FAILURE,
	type FetchSuggestedTopicsFailureAction,
} from '../../actions/fetch-suggested-topics-failure/index.tsx';
import {
	FETCH_SUGGESTED_TOPICS_SUCCESS,
	type FetchSuggestedTopicsSuccessAction,
} from '../../actions/fetch-suggested-topics-success/index.tsx';
import {
	FETCH_SUGGESTED_TOPICS,
	type FetchSuggestedTopicsAction,
} from '../../actions/fetch-suggested-topics/index.tsx';
import {
	FETCH_AI_DRAFT_CONTENT,
	type FetchAIDraftContentAction,
} from '../../actions/fetch-ai-draft-content/index.tsx';
import {
	FETCH_AI_DRAFT_CONTENT_SUCCESS,
	type FetchAIDraftContentSuccessAction,
} from '../../actions/fetch-ai-draft-content-success/index.tsx';
import {
	FETCH_AI_DRAFT_CONTENT_FAILURE,
	type FetchAIDraftContentFailureAction,
} from '../../actions/fetch-ai-draft-content-failure/index.tsx';

type Action =
	| FetchSuggestedTopicsAction
	| FetchSuggestedTopicsSuccessAction
	| FetchSuggestedTopicsFailureAction
	| FetchAIDraftContentAction
	| FetchAIDraftContentSuccessAction
	| FetchAIDraftContentFailureAction;

export const defaultState: FetchSuggestedTopicsResponse = {
	topics: [],
};

export const topicsReducer = (
	state: FetchSuggestedTopicsResponse = defaultState,
	action: Action,
): FetchSuggestedTopicsResponse => {
	switch (action.type) {
		case FETCH_SUGGESTED_TOPICS_SUCCESS:
			return {
				...state,
				topics: action.payload.topics,
			};
		case FETCH_AI_DRAFT_CONTENT_SUCCESS:
			return {
				...state,
				topics: state.topics.map((topic) =>
					topic.topicId === action.payload.topicId
						? {
								...topic,
								aiDraftPreview: {
									loading: false,
									error: null,
									data: action.payload.content,
								},
							}
						: topic,
				),
			};
		case FETCH_AI_DRAFT_CONTENT_FAILURE:
			return {
				...state,
				topics: state.topics.map((topic) =>
					topic.topicId === action.payload.topicId
						? {
								...topic,
								aiDraftPreview: {
									loading: false,
									error: action.payload.error,
									data: null,
								},
							}
						: topic,
				),
			};
		case FETCH_AI_DRAFT_CONTENT:
		case FETCH_SUGGESTED_TOPICS:
		case FETCH_SUGGESTED_TOPICS_FAILURE:
		default: {
			return state;
		}
	}
};
